"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Row = exports.HeaderCell = exports.Cell = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * See storybook for example usages.
 * If you need a simple table header with just strings, pass the `headers` prop.
 * If you need more complex content in the header, pass a `headerComponent` instead.
 */
var CardTable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CardTable, _React$Component);
  var _super = _createSuper(CardTable);
  function CardTable() {
    (0, _classCallCheck2["default"])(this, CardTable);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(CardTable, [{
    key: "header",
    value: function header() {
      var _this$props = this.props,
        headerComponent = _this$props.headerComponent,
        headers = _this$props.headers;
      if (headerComponent) return headerComponent;
      if (!headers.length) return null;
      return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, headers.map(function (header, i) {
        return /*#__PURE__*/React.createElement(CardTable.HeaderCell, {
          key: i
        }, header);
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(CardTableWrapper, null, this.header(), /*#__PURE__*/React.createElement("tbody", null, this.props.children));
    }
  }]);
  return CardTable;
}(React.Component);
CardTable.propTypes = {
  headers: _propTypes["default"].arrayOf(_propTypes["default"].string),
  headerComponent: _propTypes["default"].element
};
CardTable.defaultProps = {
  headers: []
};
var CardTableWrapper = _styledComponents["default"].table.withConfig({
  displayName: "card_table__CardTableWrapper"
})(["width:100%;border-collapse:collapse;", ""], function (props) {
  return !props.theme.legacyPadding && (0, _styledComponents.css)(["", "{padding:16px 24px 0 0;}", "{&:last-child > td{padding-bottom:0;}}", "{padding:20px 24px 20px 0;}& > tbody:only-child > tr:first-of-type > td{padding-top:24px;}thead + tbody > tr:first-of-type > td{padding-top:20px;}"], CardTable.HeaderCell, CardTable.Row, CardTable.Cell);
});
CardTable.HeaderCell = _styledComponents["default"].th.withConfig({
  displayName: "card_table__HeaderCell"
})(["", ";color:", ";font-size:12px;padding:0 25px 10px 0;text-align:left;width:", ";", ""], (0, _constants.fontWeight)('normal'), _constants.colors.mediumGrey, function (props) {
  return props.width ? props.width : '20%';
}, function (props) {
  return !props.width && "&:first-child { width: 32%; }\n     &:last-child { width: 8%; }\n    ";
});
CardTable.Row = _styledComponents["default"].tr.withConfig({
  displayName: "card_table__Row"
})(["& + &{border-top:1px solid ", ";}"], _constants.colors.lightGrey);
CardTable.Cell = _styledComponents["default"].td.withConfig({
  displayName: "card_table__Cell"
})(["font-size:14px;padding:12px 15px 12px 0;vertical-align:top;", ";&:last-child{padding-right:0;text-align:right;}"], (0, _constants.fontWeight)('normal'));
var HeaderCell = CardTable.HeaderCell,
  Row = CardTable.Row,
  Cell = CardTable.Cell;
exports.Cell = Cell;
exports.Row = Row;
exports.HeaderCell = HeaderCell;
CardTable.displayName = 'CardTable';
HeaderCell.displayName = 'CardTable.HeaderCell';
Row.displayName = 'CardTable.Row';
Cell.displayName = 'CardTable.Cell';
var _default = CardTable;
exports["default"] = _default;